module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-route-vp",
    attrs: {
      "id": "modal-route-vp",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modal-route-vp-label"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-route-vp-label"
    }
  }, [_vm._v("Rota do Vale-pedágio (VP)")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "aggregate-data"
  }, [_c('p', [_vm._v("Transportador: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.transportador))])]), _vm._v(" "), _c('p', [_vm._v("Placa: "), _c('span', {
    directives: [{
      name: "mask-plate",
      rawName: "v-mask-plate"
    }]
  }, [_vm._v(_vm._s(_vm.summaryVP.placaVeiculo))])]), _vm._v(" "), _c('p', [_vm._v("N° TAG: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.tag))])]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("N° VP: "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.idProtocolo))])])]), _vm._v(" "), _c('div', {
    staticClass: "content-box-npadd"
  }, [_c('p', [_vm._v("Detalhes da viagem")]), _vm._v(" "), _c('div', {
    staticClass: "toll-info-box"
  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-send.svg",
      "alt": "icon send"
    }
  }), _vm._v("\n                  " + _vm._s(_vm.origin.state) + "\n                ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-location.svg",
      "alt": "icon location"
    }
  }), _vm._v("\n                  " + _vm._s(_vm.destination.state) + "\n                ")])])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n                rota:\n                "), _c('span', [_vm._v(_vm._s(_vm.summaryVP.rota))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                valor:\n                "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n                expiração:\n                "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.summaryVP.expirationVP)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-toll-info"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryVP.pracas), function(s, index) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.concessionaria))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(s.price)))])])
  }), 0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                distância:\n                "), _c('span', [_vm._v(" KM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "4%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "36%"
    }
  }, [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "wizard-vertical"
  }, [_c('span')])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-37acf04a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/modal-route-vp.vue
// module id = 2096
// module chunks = 1